"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _reactSvg = require("react-svg");
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
var _Heading = _interopRequireDefault(require("../../Atoms/Heading"));
require("./ExperienceFooter.scss");
var getNavData = function getNavData(experienceFooter) {
  var navData = [];
  var contactUsData = {};
  Object.keys(experienceFooter).forEach(function (item) {
    var data = experienceFooter[item];
    var links = (0, _lodash.get)(data, ['links'], {});
    contactUsData = (0, _lodash.get)(data, ['button'], {});
    var linksLength = Object.keys(links).length;
    if (linksLength > 0) {
      navData.push(data);
    }
  });
  return {
    navData: navData,
    contactUsData: contactUsData
  };
};
var watersDomain = 'www.waters.com';
/**
 *  Functional to check link in external OR not
 *
 * @param {object} linkObj having text and link
 *
 * Handle unnecessary payload which are not being used as link having text and link only
 */

var isNotExternal = function isNotExternal(linkObj) {
  return linkObj != null && !(0, _lodash.isEmpty)(linkObj.text) && linkObj.link.indexOf(watersDomain) !== -1 && !linkObj.link.startsWith('/');
};
var ExperienceFooter = function ExperienceFooter(experienceFooterData) {
  var experienceFooter = (0, _lodash.get)(experienceFooterData, ['root'], {});
  var _getNavData = getNavData(experienceFooter),
    navData = _getNavData.navData,
    contactUsData = _getNavData.contactUsData;
  return _react.default.createElement("section", {
    className: "experienceFooter row"
  }, Object.keys(navData).map(function (item, i) {
    var data = navData[item];
    var links = (0, _lodash.get)(data, ['links'], {});
    var navLength = Object.keys(navData).length;
    var visibleNav = 'col-md-2 col-xs-12';
    var hiddenNav = 'hidden-xs hidden-md hidden-sm';
    var classApplied = i === 0 || i === navLength - 1 ? visibleNav : hiddenNav;
    var linksData = (0, _lodash.get)(data, ['links', 'linkItems'], {});
    return _react.default.createElement("nav", {
      className: "columnItems col-lg-2 " + classApplied,
      key: item
    }, Object.keys(links) && _react.default.createElement(_Heading.default, {
      className: "heading",
      HeadingType: "h4"
    }, links.title), _react.default.createElement("ul", null, Object.keys(linksData).map(function (index) {
      var linksDataText = linksData[index].text;
      return !(0, _lodash.isEmpty)(linksDataText) && _react.default.createElement("li", {
        key: index
      }, !isNotExternal(linksData[index]) ? _react.default.createElement(_Anchor.default, {
        target: "_blank",
        className: "externalLink",
        href: linksData[index].link
      }, _react.default.createElement("div", null, linksDataText, _react.default.createElement(_reactSvg.ReactSVG, {
        src: "/static/images/externallink.svg",
        wrapper: "span"
      }))) : _react.default.createElement(_Anchor.default, {
        className: "externalLink",
        href: linksData[index].link
      }, linksDataText));
    })));
  }), contactUsData.buttonLink && _react.default.createElement("div", {
    className: "contactUs center-xs col-md-4 col-lg-2 contact-us-footer",
    key: contactUsData
  }, _react.default.createElement(_Anchor.default, {
    role: "button",
    className: "cmp-button primary dark",
    href: contactUsData.buttonLink
  }, contactUsData.buttonText)));
};
ExperienceFooter.defaultProps = {
  experienceFooterData: {}
};
var _default = ExperienceFooter;
exports.default = _default;
module.exports = exports["default"];